import { Text, Flex } from '@frontend/components';

export const PostOrPrefixInput = ({ value }: { value: string }) => {
  return (
    <Flex>
      <Text color={'inherit'}>{value}</Text>
    </Flex>
  );
};
